import { access, integrationStatus } from '@driftt/traffic-control'

export const MarketoAccessTypes = {
  HAS_ACCESS_NOT_CONNECTED: 'HAS_ACCESS_NOT_CONNECTED',
  HAS_ACCESS_CONNECTED: 'HAS_ACCESS_CONNECTED',
  NO_ACCESS: 'NO_ACCESS',
}

const hasGate = (gate) => {
  return access.hasGates(gate)
}

export const shouldShowMarketoEducation = () => {
  return true
}

export const shouldShowMarketoImports = () => {
  return true
}

export const getOrgMarketoAccessType = () => {
  if (hasGate('marketo_prompt_use_force_blocked')) {
    return MarketoAccessTypes.NO_ACCESS
  }

  if (hasGate('marketo_prompt_use')) {
    return MarketoAccessTypes.HAS_ACCESS_CONNECTED
  }

  if (hasGate('marketo_prompt_upgrade') && !hasGate('has_siftrock_bots_v2')) {
    return MarketoAccessTypes.NO_ACCESS
  }

  if (!integrationStatus.isIntegrationConnected('marketo')) {
    return MarketoAccessTypes.HAS_ACCESS_NOT_CONNECTED
  }

  return MarketoAccessTypes.HAS_ACCESS_CONNECTED
}
